import { AjaxPost, IAjaxPostConfig } from "../Services/index";
import { UrlSegments } from "../Helpers/index";

//export class EventManager {
//    addListener = (objName, eventName, func) => {
//        $(document).bind(objName + '-' + eventName, func);
//    };
//    fireEvent = (objName, eventName, data, other) => {
//        $(document).trigger(objName + '-' + eventName, [data, other]);       
//    }
//};

export class ListenEvent {

    static clickJumpToTop = () => {
        $('.jump-to-top').on('click', function () {
            $("html, body").animate({ scrollTop: 0 }, "slow");
        });
    }

    static clickDropdownSubmenu = () => {
        // Dropdown Sub-menu Event Listener
        $('.dropdown-menu a.dropdown-toggle').on('click', function (e) {
            if (!$(this).next().hasClass('show')) {
                $(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
            }
            var $subMenu = $(this).next(".dropdown-menu");
            $subMenu.toggleClass('show');


            $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function (e) {
                $('.dropdown-submenu .show').removeClass("show");
            });


            return false;
        });
    }

    static activeMyAccountNavTab = () => {
        //My Account Navigation Tabs Event Listener
            let navActiveTabConditions = function () {
                if (UrlSegments().length > 0) {
                    if (UrlSegments().indexOf("MyAccount") !== -1)
                        return true;
                    if (UrlSegments().indexOf("SalesRep") !== -1)
                        return true;
                }
                else
                    return false;
            };

        if (navActiveTabConditions) {
            $(function () {
                let path = "/" + UrlSegments(0) + "/" + UrlSegments(1);
                $('.nav-myaccount').find('.active').removeClass('active');
                $('.nav-myaccount li a').each(function () {
                    if (this.getAttribute('href') == path) {
                        $(this).addClass('active');
                        $(this).parent().siblings('.dropdown-toggle').addClass('active');
                    }
                });
            });
        };
    }

    static clickRevertImpersonation = () => {
      // Revert Impersonation Event Listener
        $('span#revert-impersonation').click(function () {
            let usr = (<any>window).UserMeta;
            if (usr && usr.isImpersonating) {
                let ajaxConfig: IAjaxPostConfig = {
                    backdrop: true,
                    endpoint: "/MyAccount/RevertImpersonation",
                    payload: JSON.stringify({
                        OriginalUsername: usr.OriginalUsername,
                        UserToImpersonate: usr.UserID
                    }),
                    cbFunction: function (data) {
                        $('#page-preloader').hide();
                        $(".modal-backdrop").remove();
                        window.location.href = "/MyAccount/UserImpersonation";
                    },
                    errFunction: function (err) {
                        $('#page-preloader').hide();
                        $(".modal-backdrop").remove();
                    }
                }

                new AjaxPost(ajaxConfig);
            }
            
        })
    };

    static listenXHRDownloadStatus = () => {
        var xhr = new (<any>window).XMLHttpRequest();
        ////Upload progress
        xhr.upload.addEventListener("progress", function (evt) {
            if (evt.lengthComputable) {
                var percentComplete = evt.loaded / evt.total;
                var completedString = (100 * percentComplete).toFixed(2) + '%';
                console.debug("Upload progress", completedString);
                //Do something with upload progress
                
                $('.progress').css({
                    width: percentComplete * 100 + '%'
                });
                $('#progress-percent').text(' loading data ' + (100 * evt.loaded / evt.total).toFixed(1) + '%');
                if (percentComplete === 1) {
                    $('.progress').addClass('hide');
                }
            }
        }, false);
        //Download progress
        xhr.addEventListener("progress", function (evt) {
            if (evt.lengthComputable) {
                var percentComplete = evt.loaded / evt.total;
                var completedString = (100 * percentComplete).toFixed(2) + '%';
                console.debug("Download progress", completedString);
                //Do something with download progress

                $('.progress').css({
                    width: percentComplete * 100 + '%'
                });
                $('#progress-percent').text(' loading data ' + (100 * evt.loaded / evt.total).toFixed(1) + '%');
                if (percentComplete === 1) {
                    $('.progress').addClass('hide');
                    $('.progress').css({ width: 0 });
                }
            }
        }, false);
        return xhr;
    }

    public static WaitForCartVM = new Promise((resolve) => {
        // Checker function. Checks at every ajax success to see 
        // if the header is finally available before passing the object in

        $(document).ajaxComplete((event, xhr, options) => {
            if (options.url.split('?')[0] !== "/MyAccount/CartsSavedList") {
                return;
            }

            let check = true;

            if (check) {
                let cartVM = window.cartVM;
                resolve(cartVM);
                check = false;
                console.debug("Latest cart view model", cartVM);
            }

        });

    })

}